import React from 'react';
import { Container } from 'react-bootstrap';
import SuccessIcon from 'assets/img/verification/success.svg';
import { useSearchParams } from 'react-router-dom';
import Error404 from 'pages/error/Error404';
import ResetForgottenPassword from 'components/modules/auth/ForgotPassword/ResetForgottenPasword/ResetForgottenPasword';

function ResetPassword() {
  const [URLSearchParams] = useSearchParams();
  const token = URLSearchParams.get('token');

  if (!(URLSearchParams.size === 1 && token)) return <Error404 />;
  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center flex-column"
    >
      <img src={SuccessIcon} width={150} className="mb-2" />
      <p className="fs-4">Reset Your Password</p>
      <p className="text-center mb-4">
        Please set a new password below and
        <br />
        click 'Reset Password' to update your account credentials.
      </p>

      <ResetForgottenPassword token={token} />
    </Container>
  );
}

export default ResetPassword;
